export enum Category {
  phones = 'Mobiler',
  postPaid = 'Abonnemang',
  prePaid = 'Kontantkort',
  accessory = 'Tillbehör',
  used = 'Begagnat',
  student = 'Student',
  insurances = 'Försäkringar',
  buyback = 'Returfraktsedlar',
  family = 'Familjeabonnemang',
}
